import React from "react";
import * as util from "../../../other/util.js";
import { FleetTaskCommitButtons } from "./fleet-task-commit-buttons.js";
import FleetTaskFactory from "./fleet-task-factory.js";

export class Task extends React.Component {

    render() {
        let task = this.props.task;
        let border_color = task.pending ? "green" : undefined;
        let steps = FleetTaskFactory.createStepObjects(task.steps, task.pending);

        return (
            <div className="fleet-task-box" style={{ borderColor: border_color }}>
                <h4>{this.name}</h4>
                {this._getTaskDescription()}
                <br />
                {steps.map((step, idx) => this._renderStep(step, idx))}
                <FleetTaskCommitButtons pending={task.pending}
                    mode={this.props.mode}
                    onCommitTask={() => this.props.onCommitTask(task)}
                    onCancelTask={() => this.props.onDeleteTask(task)} />
            </div>)
    }

    _renderStep(step, idx) {
        step.doPreRenderPredictions(this.props, idx);
        let res = step.render(this.props, idx);
        step.doPostRenderPredictions(this.props, idx);

        let color = step._isStepDone(this.props, idx) ? "green" : "orange";
        return (
            <div key={idx} style={{ borderLeft: "5px solid " + color, paddingLeft: "10px", marginBottom: "10px" }}>
                {res}
            </div>);
    }

    _getTaskDescription() {
        switch (this.props.task.type) {
            case "LAUNCH":
                return (<div>
                    <span>Loading resources and deploying fleet to orbit: </span>
                    <util.PlanetLink planet={this.props.task.location} showOwner={true} />
                </div>);
            case "COLONIZE":
                return (<div>
                    <span>Land on the planet and try to colonize it: </span>
                    <util.PlanetLink planet={this.props.prediction.getLocation()} showOwner={true} />
                </div>);
            case "STATION":
                return (<div>
                    <span>Land on the planet, unload and station in the shipyard: </span>
                    <util.PlanetLink planet={this.props.prediction.getLocation()} showOwner={true} />
                </div>);
            case "MOVE":
                return (<div>
                    <span>Deploying the fleet to: </span>
                    <util.PlanetLink planet={this.props.task.location} showOwner={true} />
                </div>);
            case "RAID":
                return (<div>
                    <span>Land on the planet, raid, and launch again: </span>
                    <util.PlanetLink planet={this.props.prediction.getLocation()} showOwner={true} />
                </div>);
            case "REPAIR":
                return (<div>
                    <span>Repair the fleet.</span>
                </div>);
            case "MISSION":
                return (<div>
                    <span>Perform the available mission on the planet: </span>
                    <util.PlanetLink planet={this.props.task.location} showOwner={false} />
                </div>);
            default:
                return (<div>
                    <span>UNKNOWN TASK</span>
                </div>)
        }
    }
}
